module.exports = __webpack_public_path__ + "img/LTC-ability-05.ae8bccce.png";